import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCards, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-cards";
import { useNavigate } from "react-router-dom";
import { getAllGiftCards } from "../../../services/giftCardService";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { setPurchaseToken } from "../../../redux/slices/giftCardCheckoutSlice";
const GiftCards = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { giftCards, loading } = useSelector((state) => state.giftCardReducer);
  const [page, setPage] = useState(1);
 const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  // useEffect(() => {
  //   dispatch(getAllGiftCards({ page: 1, limit: 20 }));
  // }, [dispatch]);
// useEffect(() => {
//   if (token && giftCards) {
//     dispatch(getAllGiftCards({ page: 1, limit: 20, token }))
//       .then(() => {
        
//         dispatch(setPurchaseToken(token)); 
//             console.log("Dispatched purchase token:", token);
//       });
//   }
// }, [dispatch, token]);

  // useEffect(() => {
  //    dispatch(getAllGiftCards({ page: 1, limit: 20 }));
  //     if (token) {
  //       dispatch(setPurchaseToken(token)); 
  //        console.log("Dispatched purchase token:", token);
  //     }
    
  // }, [dispatch,token]);



useEffect(() => {
  if (token) {
    dispatch(getAllGiftCards({ page: 1, limit: 20, token }));
    dispatch(setPurchaseToken(token)); 
    console.log("Dispatched purchase token:", token);
  }
}, [dispatch, token]);















  const handleSlideClick = (id, title) => {
    navigate(`/gift-card/${title}/${id}`);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-[80vh]">
        <p className="text-gray-500 text-lg font-medium">Loading gift cards...</p>
      </div>
    );
  }

  if (!giftCards || giftCards.length === 0) {
    return (
      <div className="flex items-center justify-center h-[80vh]">
        <p className="text-gray-500 text-lg font-medium">No Gift Cards Found</p>
      </div>
    );
  }

  return (
    <div className="p-4 flex flex-col items-center min-h-[90vh] w-full overflow-hidden mt-4">
      <div className="px-2 w-full flex flex-col items-center">
       <Swiper
  className="w-full max-w-4xl h-[70vh]"
  effect="cards"
  grabCursor={true}
  modules={[EffectCards, Navigation]}
  navigation={true}
  centeredSlides={true}
  cardsEffect={{
    perSlideOffset: 8,
    perSlideRotate: 2,
    rotate: false,
    slideShadows: false,
  }}
>
  {giftCards.map((item) => (

      <SwiperSlide
  key={item._id}
  onClick={() =>
    handleSlideClick(item._id, item.productName.replace(/\s+/g, "-"))
  }
  className="cursor-pointer flex items-center justify-center"
>
  <div className="flex flex-col h-full w-full rounded-2xl 
                  bg-[00ADEF] border border-gray-400 
                 hover:transition duration-300 overflow-hidden">
  
    <div className="flex-grow flex items-center justify-center p-4 bg-[#00ADEF]">
      <div className="w-full h-full flex items-center justify-center bg-[#00ADEF] rounded-xl overflow-hidden">
        <img
          src={
            item.productImage ||
            "https://via.placeholder.com/400x250?text=No+Image"
          }
          alt={item.productName}
          // className="object-contain max-h-60 rounded-lg transition-transform duration-300 hover:scale-105"
                className="p-5 object-contain h-[260px] rounded-lg transition-transform duration-300 scale-x-125 hover:scale-x-150"

        />
      </div>
    </div>
    <div className="p-4 border-t border-gray-400 bg-white">
      <h3 className="text-base font-semibold text-black font-poppins">
        {item.parentBrandName || item.productName}
      </h3>
      <p className="mt-2 text-sm text-gray-400 font-poppins line-clamp-2 font-normal">
        {item.productDescription || "No description available."}
      </p>
    </div>
  </div>
</SwiperSlide>

  ))}
</Swiper>


      </div>
    </div>
  );
};

export default GiftCards;